// Draggable Categories constants
export const GENERALES = "Générale";
export const MATERIELS = "Materiel";
export const SILOUHETTES = "Silouhettes";
export const FORMES_GEO = "Formes géométriques";
export const FIELDS = "Terrains";